import {
    ORDER_SCANNING_RECEIVE,
} from '../Actions/OrderScanning.action';

const DEFAULT_STATE = {
   
};

export const orderScanning = (state = DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case ORDER_SCANNING_RECEIVE:
            return {
                ...state,
                ...payload,
            };
        default:
            return state;
    }
};
